var moment = require('js/lib/moment');

module.exports = function() {

  return function(minutes) {
    if (! minutes) return null;

    var duration = moment.duration(minutes, 'minutes');
    var days = Math.floor(duration.asDays());
    var hours = duration.hours() + (days * 24);

    if (hours===0) {
      return duration.minutes() + 'm ' + duration.seconds() + 's';
    } else {
      return hours + 't ' + duration.minutes() + 'm';
    }

  };

};



/*****************
 ** WEBPACK FOOTER
 ** ./src/js/filters/duration.js
 ** module id = 161
 ** module chunks = 1
 **/